import { Component, AfterViewInit, Signal, ViewChild, ElementRef, signal } from '@angular/core';
import { SchedulerService } from '../../services/scheduler.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateTime } from 'luxon';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { SchedulerHeaderComponent } from '../scheduler-header/scheduler-header.component';
import { ScheduleToolbarComponent } from '../schedule-toolbar/schedule-toolbar.component';
import { AppointmentEntryComponent } from '../appointment-entry/appointment-entry.component';

@Component({
  selector: 'app-scheduler-holder',
  imports: [
    CommonModule, FormsModule, MatInputModule, MatFormFieldModule, MatSelectModule, MatListModule, MatIconModule, MatButtonModule,
    MatDatepickerModule, MatNativeDateModule,
    SchedulerHeaderComponent, ScheduleToolbarComponent, AppointmentEntryComponent
  ],
  templateUrl: './scheduler-holder.component.html',
  styleUrl: './scheduler-holder.component.css'
})
export class SchedulerHolderComponent implements AfterViewInit {
  @ViewChild('scrollSync') scrollSync!: ElementRef;
  data: any;
  selectedDate: Date = new Date();
  entryHolderStyle: any = {
    width: '100px'
  }
  constructor(public s: SchedulerService) {
    this.data = this.s.getData();
    // Initialize with current date
    this.selectedDate = DateTime.local().toJSDate();
  }

  ngAfterViewInit() {
    this.scrollSync.nativeElement.addEventListener('scroll', () => {
      this.s.scrollPosition.set(this.scrollSync.nativeElement.scrollLeft);
    });

    this.s.setScrollSyncWidth(this.scrollSync.nativeElement.clientWidth);

    console.log('rangesInPeriod', (this.s.smallPeriodHolderWidth()));

    this.entryHolderStyle.width = this.data.scrollSyncWidth();

    //this.scrollSync.nativeElement.scrollLeft = this.s.scrollPosition();
    /*this.scrollSyncService.scrollPosition.pipe(takeUntilDestroyed()).subscribe((position) => {

    });*/
  }

  onScroll(event: Event): void {
    //const scrollLeft = (event.target as HTMLElement).scrollLeft;
    //this.s.setScrollPosition(scrollLeft);
    // Perform actions based on the scroll position
  }

  periodChanged(selectedPeriod: any) {
    console.log('periodChanged selectedPeriod', selectedPeriod);
    this.s.setSelectedView(selectedPeriod.value);
    this.s.setScrollSyncWidth(this.scrollSync.nativeElement.clientWidth);
    this.s.setEntryStyles();
    this.s.getData();
    //console.log('debug start of selectedDate', this.s.selectedDate().startOf('day').toString());
    //console.log('debug this.s', this.s.midRangesInPeriod());
  }

  scheduleClick(schedule: any) {
    console.log('scheduleClick schedule', schedule);
  }

  shouldUseGroupedView(): boolean {
    const periodId = this.s.selectedPeriod().id;
    return periodId === 'week' || periodId === 'month' || periodId === 'year';
  }

  getGroupedAppointments(scheduleId: string): any[] {
    return this.s.getAppointmentsBySmallPeriod(scheduleId);
  }

  onDateChange(selectedDate: Date | null): void {
    if (selectedDate) {
      this.selectedDate = selectedDate;
      const luxonDate = DateTime.fromJSDate(selectedDate);
      this.s.setSelectedDate(luxonDate);
      console.log('Date changed to:', luxonDate.toISODate());
      this.s.getData();
    }
  }

  getContentWidth(): number {
    // Calculate the natural content width based on the number of periods and their min-width
    const periodCount = this.s.rangesInPeriod().length;
    const minWidth = this.s.selectedPeriod().smallWidth;
    return periodCount * minWidth;
  }

  navigateForward(): void {
    const currentDate = DateTime.fromJSDate(this.selectedDate);
    const largePeriod = this.s.selectedPeriod().largePeriod;
    const newDate = currentDate.plus({ [largePeriod]: 1 });
    
    this.selectedDate = newDate.toJSDate();
    this.s.setSelectedDate(newDate);
    console.log('Navigated forward to:', newDate.toISODate());
    this.s.getData();
  }

  navigateBackward(): void {
    const currentDate = DateTime.fromJSDate(this.selectedDate);
    const largePeriod = this.s.selectedPeriod().largePeriod;
    const newDate = currentDate.minus({ [largePeriod]: 1 });
    
    this.selectedDate = newDate.toJSDate();
    this.s.setSelectedDate(newDate);
    console.log('Navigated backward to:', newDate.toISODate());
    this.s.getData();
  }

}
